import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-trash',
  templateUrl: './icon-trash.component.html',
  standalone: false,
})
export class IconTrashComponent {}
